import MarqueeText from './MarqueeText'

export const SidebarPanelContent = ({ icon, title, subtitle, trailing }) => (
  <>
    {icon}
    <span className="site-panel-body min-w-0 flex-1">
      <MarqueeText text={title} className="site-panel-title" />
      {subtitle ? <MarqueeText text={subtitle} className="site-panel-subtitle mt-1" /> : null}
    </span>
    {trailing}
  </>
)
